import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { FadeUp, SectionHead } from "../Reveal";
import { SERVICES } from "../../data/services";
import { waLink } from "../../data/site";
import { track } from "../../lib/analytics";

export const ServicesGrid = () => (
    <section id="servicos" data-testid="services-section" className="bg-paper py-20 sm:py-28 lg:py-32">
        <div className="container-x">
            <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8">
                <SectionHead
                    tag="03 — Serviços"
                    title="Uma central completa de produção para a sua marca."
                    sub="Nove frentes de trabalho para cobrir praticamente tudo o que o seu negócio precisa imprimir, vestir ou sinalizar."
                />
            </div>

            <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
                {SERVICES.map((s, i) => (
                    <FadeUp key={s.slug} delay={(i % 3) * 0.08} className="h-full">
                        <article
                            data-testid={`service-card-${s.slug}`}
                            className="group relative flex h-full flex-col overflow-hidden rounded-2xl border border-[#E9E9E9] bg-white transition-all duration-500 hover:-translate-y-1.5 hover:shadow-[0_24px_60px_-24px_rgba(13,13,13,0.25)]"
                        >
                            <Link to={`/servicos/${s.slug}`} data-testid={`service-link-${s.slug}`} className="relative block overflow-hidden" aria-label={`Ver detalhes de ${s.name}`}>
                                <img
                                    src={s.image}
                                    alt={`${s.name} em Campinas — IMPRIMA AKI`}
                                    loading="lazy"
                                    className="aspect-[16/10] w-full object-cover transition-transform duration-700 group-hover:scale-[1.05]"
                                />
                                <span className="absolute left-4 top-4 rounded-full bg-ink/80 px-3 py-1 font-mono text-[10px] uppercase tracking-[0.2em] text-white backdrop-blur-sm">
                                    {String(i + 1).padStart(2, "0")}
                                </span>
                            </Link>
                            <div className="flex flex-1 flex-col p-6">
                                <h3 className="font-display text-xl font-bold tracking-tight text-ink">
                                    <Link to={`/servicos/${s.slug}`} className="transition-colors hover:text-brand">{s.name}</Link>
                                </h3>
                                <p className="mt-2 flex-1 text-sm leading-relaxed text-smoke">{s.short}</p>
                                <div className="mt-6 flex items-center justify-between border-t border-[#F0F0F0] pt-4">
                                    <a
                                        href={waLink(`Olá! Gostaria de orçar: ${s.name}. Vim pelo site da Imprima Aki.`)}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        onClick={() => track("whatsapp_click", { location: "service_card", service: s.slug })}
                                        data-testid={`service-orcar-${s.slug}`}
                                        className="inline-flex items-center gap-2 rounded-full bg-ink px-5 py-2.5 text-xs font-bold uppercase tracking-wider text-white transition-colors duration-300 hover:bg-brand"
                                    >
                                        Orçar
                                        <ArrowUpRight size={14} />
                                    </a>
                                    <Link
                                        to={`/servicos/${s.slug}`}
                                        data-testid={`service-details-${s.slug}`}
                                        className="text-xs font-bold uppercase tracking-wider text-smoke transition-colors hover:text-brand"
                                    >
                                        Detalhes
                                    </Link>
                                </div>
                            </div>
                            <span className="absolute inset-x-0 bottom-0 h-[3px] origin-left scale-x-0 bg-brand transition-transform duration-500 group-hover:scale-x-100" />
                        </article>
                    </FadeUp>
                ))}
            </div>
        </div>
    </section>
);
